/**
 * "No forms detected" names the page where a form most likely lives: the most
 * clicked page whose path reads like a demo, sign-up, contact or quote page.
 * Paths only, so a site without such a page gets the plain sentence.
 */
const FORM_INTENT = /(^|[/_-])(demo|book|contact|sign-?up|register|trial|get-started|start|quote|apply|join|subscribe|waitlist)([/_-]|$)/i

export type FormIntentPage = { page: string; clicks: number }

export function pickFormIntentPage(rows: Array<{ page: string; total_clicks: number }>): FormIntentPage | null {
  let best: FormIntentPage | null = null
  for (const row of rows) {
    if (!row.page || row.total_clicks <= 0 || !FORM_INTENT.test(row.page)) continue
    if (!best || row.total_clicks > best.clicks) best = { page: row.page, clicks: row.total_clicks }
  }
  return best
}
